import { render, staticRenderFns } from "./OnboardingFourthQuestion.vue?vue&type=template&id=04820442"
import script from "./OnboardingFourthQuestion.vue?vue&type=script&lang=js"
export * from "./OnboardingFourthQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports